import { mdiClipboardAccountOutline } from '@mdi/js'

export default [
  {
    title: 'Menu.Satchel',
    icon: mdiClipboardAccountOutline,
    resource: 'all',
    action: 'can_see_dashboard',
    children: [
      {
        to: 'managementSatchel',
        title: 'Satchel.ManagementSatchel.Menu',
        resource: 'all',
        action: 'can_see_management_satchel_menu',
      },
      {
        to: 'sellSatchel',
        title: 'Satchel.SellSatchel.Menu',
        resource: 'all',
        action: 'can_see_sell_satchel_menu',
      },
      {
        to: 'buySatchel',
        title: 'Satchel.BuySatchel.Menu',
        resource: 'all',
        action: 'can_see_buy_satchel_menu',
      },
      {
        to: 'accountantSatchel',
        title: 'Satchel.AccountantSatchel.Menu',
        resource: 'all',
        action: 'can_see_accountant_satchel_menu',
      },
      {
        to: 'installerSatchel',
        title: 'Satchel.InstallerSatchel.Menu',
        resource: 'all',
        action: 'can_see_installer_satchel_menu',
      },
      {
        to: 'productSatchel',
        title: 'Satchel.ProductSatchel.Menu',
        resource: 'all',
        action: 'can_see_product_satchel_menu',
      },
      {
        to: 'productExportSatchel',
        title: 'Satchel.ProductExport.Menu',
        resource: 'all',
        action: 'can_see_product_export_menu',
      },
    ],
  },
]
